var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterpeace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 213,
    viewBox: "0 0 215 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.484 94.3227L7.73841 31.0481C3.84445 85.5616 45.0555 105.68 66.1478 108.925L27.2082 147.863H66.1478V133.261C112.875 137.155 121.312 105.68 119.69 89.4554L124.557 79.7209L139.159 74.8536L129.425 69.9863C129.425 66.7415 126.504 60.2517 114.822 60.2517C103.14 60.2517 100.22 69.9863 100.22 74.8536L100.219 11.579C80.4925 21.3135 70.7576 34.148 70.7576 63.3517",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.892 84.3439L136.892 34.941",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.224 25.8548C150.136 33.6444 139.041 37.4396 139.041 37.4396C139.041 37.4396 131.33 28.6054 133.417 20.8158C135.505 13.0263 146.6 9.23104 146.6 9.23104C146.6 9.23104 154.311 18.0652 152.224 25.8548Z",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.009 43.1023C145.363 47.157 145.681 57.2592 145.681 57.2592C145.681 57.2592 155.152 60.7875 160.798 56.7328C166.445 52.6781 166.127 42.5758 166.127 42.5758C166.127 42.5758 156.655 39.0475 151.009 43.1023Z",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.076 56.7854L136.893 64.8158",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.446 180.744C193.221 180.744 193.221 206.262 171.996 206.262C150.771 206.262 150.771 180.744 129.546 180.744C108.321 180.744 108.321 206.262 87.0963 206.262",
    stroke: "#0050C0",
    strokeWidth: 6.63462,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.446 146.038C193.221 146.038 193.221 171.556 171.996 171.556C150.771 171.556 150.771 146.038 129.546 146.038C108.321 146.038 108.321 171.556 87.0963 171.556",
    stroke: "#0050C0",
    strokeWidth: 6.63462,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterpeace);
export default __webpack_public_path__ + "static/media/waterpeace.e475133b6d85cb4cb6bfb674c218b77c.svg";
export { ForwardRef as ReactComponent };